// extracted by mini-css-extract-plugin
module.exports = {"page":"Contact_page__3HmRa","form":"Contact_form__1jjLU","input":"Contact_input__2VvXX","credits":"Contact_credits__Vh-Ue"};